module.exports = __webpack_public_path__ + "static/img/19034C_3_4_C_20220323_LC.826718a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19034C_3_4_C_20220323_LC.png
// module id = uRgS
// module chunks = 0